import { Component, OnInit } from '@angular/core';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { CtxMenuLabelEnum } from 'src/app/core/components/ctxMenu/ctx-menu-config';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { PdaAuthService } from '../../utils/Service/pda-auth.service';
import { FascicoloService } from 'src/app/penale/fascicoloFormShared/services/get-model-fascicolo.service';

@Component({
  selector: 'app-pct-sidebar-link',
  templateUrl: './pct-sidebar-link.component.html',
  styleUrls: ['./pct-sidebar-link.component.css']
})
export class PctSidebarLinkComponent implements OnInit {

  opt = {
    label: CtxMenuLabelEnum.CANCELLERIA_TELEMATICA,
    url: UrlSettingsCore.URL_CANCELLERIA_TELEMATICA,
    class: ["cancelleria-telematica","cancelleria-telematica disabled"],
    descriptor: NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA,
    feature : ConfigurationFeature.JUSTICE_PDA,
    disabled: true
}

  constructor(private auth: PdaAuthService){

  }

  ngOnInit(): void {
    this.auth.isLogged.subscribe((res) =>this.opt.disabled = !res);
  }

}
